import React, { useEffect, useState } from "react";
import FormSectionLayout from "../../layouts/FormSectionLayout";
import HeadingText from "../../common/HeadingText/HeadingText";
import { Container, Form, Row, Col } from "reactstrap";
import "./TourCreation.scss";
import ButtonComponent from "../../common/Button/ButtonComponent";
import LoaderComponent from "../../common/Loader/Loader";
import Toaster from "../../common/Toaster/Toaster";
import {
  normalize3plCSVUploadPayload,
  normalizeWarehouseResponseForDropdown,
} from "../../../normalizer/ShipperNormalizer";
import { Can } from "../../../config/Can";
import { acceptableFormats } from "../../../config/constants";
import { UPLOAD_3PL_PLAN_TOURS_CSV_URL } from "../../../config/Url";
import {
  ITour3plPayload,
  ITourCreationPageProps,
} from "./../../../interfaces/tourCreation.interface";
import UploadButtonComponent from "../../common/UploadButton/UploadButtonComponent";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import { IDeliveryOption, IWarehousePayload } from "interfaces/Index";

const headingText = "3rd party logistics";
const buttonText = "Submit";

const TourCreationPage: React.FunctionComponent<ITourCreationPageProps> = (
  props
) => {
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [warehouseSelected, setSelectedWarehouse] =
    useState<IWarehousePayload | null>(null);
  const [deliverySelected, setSelectedDelivery] =
    useState<IDeliveryOption | null>(null);

  const [tour3plPayload, setTour3plPayload] = useState<ITour3plPayload>({
    file: null,
    planId: "",
    batchId: "",
    warehouseId: "",
    deliveredBy: "",
  });

  useEffect(() => {
    const { getWarehouses, getDeliveryOptions } = props;
    getDeliveryOptions();
    getWarehouses();
  }, []);

  useEffect(() => {
    const { isSubmitted } = props;
    if (isSubmitted) {
      const message = "Plan for 3pl created successfully!";
      handleToaster(false, message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [props.isSubmitted]);

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
    }
  }, [props.isError]);

  const validateForm =
    props.dummyValidation ||
    !!(
      tour3plPayload.warehouseId &&
      tour3plPayload.deliveredBy &&
      tour3plPayload.file
    );

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleCSVInputChange = (file: any) => {
    if (file) {
      setTour3plPayload({
        ...tour3plPayload,
        ["file"]: file,
      });
    }
  };

  const handleSubmit = () => {
    const { upload3plTourCsv } = props;
    let payload: FormData = normalize3plCSVUploadPayload(
      tour3plPayload.warehouseId,
      tour3plPayload.deliveredBy,
      tour3plPayload.file
    );

    upload3plTourCsv(payload, UPLOAD_3PL_PLAN_TOURS_CSV_URL);
  };

  const handleWarehouseChange = (selectedOption: any) => {
    setSelectedWarehouse(selectedOption);
    handleSelectChange(selectedOption, "warehouseId");
  };

  const handleDeliveryChange = (selectedOption: any) => {
    setSelectedDelivery(selectedOption);
    handleSelectChange(selectedOption, "deliveredBy");
  };

  const handleSelectChange = (e: any, fieldId: string) => {
    setTour3plPayload({
      ...tour3plPayload,
      [fieldId]: e.id,
    });
  };

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row
          id="addEditButtonRow"
          className="add-update-button-container tour-button"
        >
          <Can I="create" a="plan">
            <Col lg="6">
              <ButtonComponent
                buttonClass="large-button btn-primary"
                buttonText={buttonText}
                onClickHandler={handleSubmit}
                isDisable={props.isLoading || !validateForm}
              />
            </Col>
            <Col lg="6">
              <UploadButtonComponent
                id="upload-3pl-csv"
                buttonText="Upload .CSV"
                fileFormat={acceptableFormats.csv}
                handleFileChange={handleCSVInputChange}
                classes="button-medium"
              />
            </Col>
          </Can>
        </Row>
      </div>
    );
  };

  const renderTourCreation = () => {
    return (
      <FormSectionLayout subTitleText="Assignment">
        <section className="form-group search-container">
          <SearchableSelect
            label="Warehouse"
            isSearchable
            placeholder="Select Warehouse"
            options={normalizeWarehouseResponseForDropdown(props.warehouseList)}
            id="warehouseId"
            onChange={handleWarehouseChange}
            selectedValue={warehouseSelected}
          />
        </section>
        <section className="form-group search-container">
          <SearchableSelect
            label="Delivered By"
            isSearchable
            options={props.deliveryOptions}
            id="deliveredBy"
            onChange={handleDeliveryChange}
            placeholder="Select Delivery"
            selectedValue={deliverySelected}
          />
        </section>
        {renderFormButton()}
      </FormSectionLayout>
    );
  };

  return (
    <Container fluid className="tour-creation-container">
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row className="tour-assignment-heading">
        <Col lg="6">
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="">{renderTourCreation()}</div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

TourCreationPage.defaultProps = {
  dummyValidation: false,
};

export default TourCreationPage;
